"use strict";

exports.__esModule = true;
exports.system = system;

var _parser = require("./parser");

var _systemConfig = require("./systemConfig");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function system(configs) {
  var config = {};

  for (var _key in configs) {
    var value = configs[_key];

    if (value === true) {
      config[_key] = (0, _systemConfig.createSystemConfig)({
        property: _key,
        scale: _key
      });
      continue;
    }

    config[_key] = (0, _systemConfig.createSystemConfig)(_extends({}, value));
  }

  var parser = (0, _parser.createParser)(config);
  return parser;
}